var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sq-logo"},[_c('p',[_vm._v("powered by 松鼠Ai")]),_c('img',{attrs:{"src":require("../../../assets/images/logo_blue.png"),"alt":""}})])
}]

export { render, staticRenderFns }